module.exports = __webpack_public_path__ + "2020celebration/img/p1.d137c6a1.png";